import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {userService} from '@/services/userService'

const EMAILS_KEY = ['user', 'emails']
const PHONES_KEY = ['user', 'phones']

export function useUserEmails() {
  return useQuery({
    queryKey: EMAILS_KEY,
    queryFn: async () => {
      const result = await userService.listEmails()
      if (!result.success) throw new Error(result.error)
      return result.emails
    },
  })
}

export function useAddEmail() {
  return useMutation({
    mutationFn: (email) => userService.addEmail(email),
  })
}

export function useRequestEmailOtp() {
  return useMutation({
    mutationFn: (email) => userService.requestEmailOtp(email),
  })
}

export function useVerifyEmailOtp() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({email, otp}) => userService.verifyEmailOtp(email, otp),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({queryKey: EMAILS_KEY})
        queryClient.invalidateQueries({queryKey: ['user', 'account']})
      }
    },
  })
}

export function useSetDefaultEmail() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (email) => userService.setDefaultEmail(email),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({queryKey: EMAILS_KEY})
        queryClient.invalidateQueries({queryKey: ['user', 'account']})
      }
    },
  })
}

export function useUserPhones() {
  return useQuery({
    queryKey: PHONES_KEY,
    queryFn: async () => {
      const result = await userService.listPhones()
      if (!result.success) throw new Error(result.error)
      return result.phones
    },
  })
}

export function useAddPhone() {
  return useMutation({
    mutationFn: ({phone, countryCode}) => userService.addPhone(phone, countryCode),
  })
}

export function useRequestPhoneOtp() {
  return useMutation({
    mutationFn: (phone) => userService.requestPhoneOtp(phone),
  })
}

export function useVerifyPhoneOtp() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({phone, otp}) => userService.verifyPhoneOtp(phone, otp),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({queryKey: PHONES_KEY})
        queryClient.invalidateQueries({queryKey: ['user', 'account']})
      }
    },
  })
}

export function useSetDefaultPhone() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (phone) => userService.setDefaultPhone(phone),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({queryKey: PHONES_KEY})
        queryClient.invalidateQueries({queryKey: ['user', 'account']})
      }
    },
  })
}

export function useUserAddresses() {
  return useQuery({
    queryKey: ['user', 'addresses'],
    queryFn: async () => {
      const result = await userService.listAddresses()
      if (!result.success) throw new Error(result.error)
      return result.addresses
    },
  })
}

export function useAddAddress() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload) => userService.addAddress(payload),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({queryKey: ['user', 'addresses']})
      }
    },
  })
}

